import { render, staticRenderFns } from "./Schritt1.vue?vue&type=template&id=65a431f1&"
import script from "./Schritt1.vue?vue&type=script&lang=js&"
export * from "./Schritt1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports